import React from "react";
import { Box } from "@mui/material";
export {
  useResizablePanel,
  useResizableRightPanel,
} from "../../hooks/useResizablePanel";

export const SIDEBAR_DEFAULT = 200;
export const SIDEBAR_MIN = 160;
export const SIDEBAR_MAX = 420;

export const CONFIG_PANEL_DEFAULT = 440;
export const CONFIG_PANEL_MIN = 320;
export const CONFIG_PANEL_MAX = 640;

export const EMBEDDED_AGENT_CHAT_WIDTH = 420;
export const EMBEDDED_AGENT_CHAT_MIN = 320;
/** Max share of layout width for a right-side embedded chat (agent config page). */
export const EMBEDDED_AGENT_CHAT_MAX_WIDTH_RATIO = 0.5;

export function ResizeHandle({ onMouseDown }) {
  return (
    <Box
      sx={{
        width: 0,
        flexShrink: 0,
        position: "relative",
        overflow: "visible",
        zIndex: 2,
      }}
    >
      <Box
        onMouseDown={onMouseDown}
        sx={{
          position: "absolute",
          top: 0,
          bottom: 0,
          left: "-2.5px",
          width: "5px",
          cursor: "col-resize",
          "&::after": {
            content: '""',
            position: "absolute",
            top: 0,
            bottom: 0,
            left: "50%",
            transform: "translateX(-50%)",
            width: "1px",
            backgroundColor: "divider",
            pointerEvents: "none",
            transition: "background-color 150ms, width 150ms",
          },
          "&:hover::after": {
            backgroundColor: "text.secondary",
            width: "3px",
            borderRadius: "2px",
          },
        }}
      />
    </Box>
  );
}
